import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const DELETE_ACCOUNT_STORAGE_KEY = "DELETE_ACCOUNT";
export const DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY = "DELETE_ACCOUNT_RESPONSIVE_BYPASS";

const DeleteAccount = () => {
    const history = useHistory();

    useEffect(() => {
        localStorage.setItem(DELETE_ACCOUNT_STORAGE_KEY, "1");
        localStorage.setItem(DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY, "1");
        history.replace("/login");
    }, [history]);

    return null;
};

export default DeleteAccount;
